/** Destination source platforms accepted by the master-data API. */
export const DESTINATION_TYPES = ['heristep', 'trippass'] as const

export type DestinationType = (typeof DESTINATION_TYPES)[number]

export function isDestinationType(value: string): value is DestinationType {
  return (DESTINATION_TYPES as readonly string[]).includes(value)
}
